import * as React from 'react'
import { connect } from 'react-redux'
import { IDetailPageState } from '../../reducers'
import { ISanitizedCarousel, sanitizedCarouselSelector } from '../../selectors/carousel'
import { CarouselCollection } from './carouselCollection'
import * as stUtility from '../utilityClasses.module.scss'
import { Container } from 'DVWebNodeUI'

export interface ICarouselProps {
  carousel: ISanitizedCarousel
}

const ConnectedCarousel = ({ carousel }: ICarouselProps) => {
  return (
    <Container className={`${stUtility.pageSection}`}>
      {carousel.map((col, idx) => {
        if (col === null) {
          return null
        }
        return <CarouselCollection {...col} key={idx} />
      })}
    </Container>
  )
}

const mapStateToProps = (state: IDetailPageState): ICarouselProps => ({
  carousel: sanitizedCarouselSelector(state)
})

export const Carousel = connect(mapStateToProps)(ConnectedCarousel)
